// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"262":"locale-pt","285":"locale-ja"}[chunkId] || chunkId) + "." + {"262":"2c9bcac8","285":"fa3501bf","963":"1f3d9aca"}[chunkId] + ".chunk.js";
};